// extracted by mini-css-extract-plugin
export var cardIcon = "_7l-5";
export var checkboxCard = "_7l-0";
export var checkboxCardSelected = "_7l-4";
export var disabled = "_7l-2";
export var interactive = "_7l-1";
export var outerBorder = "_7l-3";
export var spacerMedium = "_7l-8";
export var spacerSmall = "_7l-7";
export var spacerXsmall = "_7l-6";